import * as React from "react"
import { isArray } from "@apollo/client/utilities"
import useRouter from "@digits-shared/hooks/useRouter"

export enum RequestScheme {
  Digits = "Digits",
  Https = "Https",
}

export function useMagicLinkToken() {
  const { location } = useRouter()

  return React.useMemo(() => {
    const mlParam = location.state?.from?.queryParams?.ml
    // If the ml query param appears more than once, the value will be an array,
    // and we won't know what value to choose. This is a URL generation-side error.
    // Log it so we know to go look for the source of the problem.
    // Note: Not theoretical - this has happened!
    if (isArray(mlParam)) {
      TrackJS?.track("Magic link token query param appears more than once")
    }

    // If the value is not a string, best to just ignore it as invalid.
    const token = typeof mlParam === "string" ? mlParam : undefined
    const schemeString = location.state?.from?.queryParams?.scheme as RequestScheme
    const scheme = RequestScheme[schemeString] ?? RequestScheme.Https
    return {
      token,
      scheme,
    }
  }, [location])
}
